import './assets/js/flexible.js';

import Vue from 'vue';
import App from './App.vue';
import router from './router/index.js';
import store from './store/index.js'; // vuex

import './assets/css/szui.scss';
import VueMixin from './mixin/vueMixin';
Vue.mixin(VueMixin);

import ElementUI from 'element-ui'
import './element-variables.scss'
Vue.use(ElementUI)

import "swiper/dist/css/swiper.css"

import VueAwesomeSwiper from 'vue-awesome-swiper'



Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false;

new Vue({
	render: h => h(App),
	router,
	store
}).$mount('#app')
